export default {
  get: function (key) {
    if (typeof localStorage.getItem(key) === 'string') {
      return JSON.parse(localStorage.getItem(key))
    }
  },
  set: function (key, value) {
    if (typeof key === 'number') key = String(key)
    if (typeof key === 'string') {
      localStorage.setItem(key, JSON.stringify(value))
    }
  },
  remove: function (key) {
    if (typeof key === 'string') {
      localStorage.removeItem(key)
    }
  },
  clear: function () {
    localStorage.clear()
  }
}
